// src/utils/toast.tsx
// Toasts no bloqueantes basados en notistack. Utilizable desde componentes
// (via useSnackbar) y desde codigo no-React (interceptores axios, servicios)
// gracias a una referencia global capturada por SnackbarUtilsConfigurator.
import React from 'react';
import {
  useSnackbar,
  ProviderContext,
  VariantType,
  OptionsObject,
} from 'notistack';

let snackRef: ProviderContext | null = null;

/**
 * Se monta una vez dentro del SnackbarProvider para capturar la API imperativa.
 * Permite llamar toast.* desde cualquier parte, incluso fuera de React.
 */
export const SnackbarUtilsConfigurator: React.FC = () => {
  snackRef = useSnackbar();
  return null;
};

function show(message: string, variant: VariantType, options?: OptionsObject) {
  if (!snackRef) {
    // Fallback defensivo si aun no hay provider montado
    // eslint-disable-next-line no-console
    console[variant === 'error' ? 'error' : 'log'](`[toast:${variant}]`, message);
    return;
  }
  return snackRef.enqueueSnackbar(message, { variant, ...options });
}

export const toast = {
  success: (msg: string, o?: OptionsObject) => show(msg, 'success', o),
  error:   (msg: string, o?: OptionsObject) => show(msg, 'error', { autoHideDuration: 6000, ...o }),
  info:    (msg: string, o?: OptionsObject) => show(msg, 'info', o),
  warning: (msg: string, o?: OptionsObject) => show(msg, 'warning', o),
  default: (msg: string, o?: OptionsObject) => show(msg, 'default', o),
  close:   (key?: string | number) => snackRef?.closeSnackbar(key),
};

export default toast;
